<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT" id="toc_marker-4"><a href="#/Contents#toc4">Acknowledgments</a></p>
<p class="IC-T1"><span class="char-style-override-1">M</span>any students, colleagues, and friends have assisted me in the writing of this book. I especially wish to thank those who read the manuscript in whole or in part and offered helpful comments: Cornelius Plantinga, Jr. (Professor of Systematic Theology, Calvin Theological Seminary), and several colleagues at Princeton Theological Seminary: George S. Hendry (Charles Hodge Professor Emeritus of Systematic Theology), Hugh T. Kerr (Benjamin B. War­field Professor Emeritus of Systematic Theology), Nancy Duff (Assistant Professor of Ethics), and Kathleen D. Billman and Leanne Van Dyk (Ph.D. candidates).</p>
<p class="BODY">I am also indebted to George Stroup (Professor of Systematic Theology, Columbia Theological Seminary), Michael Welker (Professor of Systematic Theology, University of Münster), and Sang Hyun Lee, Mark Kline Taylor, and David E. Willis-­Watkins (Professors of Systematic Theology, Princeton Theological Seminary), with each of whom at various times I have team taught the basic course in theology at Princeton. Just how much their ideas have enriched my own would be embarrassing to relate in detail.</p>
<p class="BODY">I am grateful to President Thomas Gillespie and the Trustees of Princeton Theological Seminary for a sabbatical leave in 1990-1991 that enabled me to complete the writing of this book. Joe Herman, a faculty assistant with extraordinary talents, helped with the typing and other details.</p>
<p class="BODY">My gratitude to my wife Margaret for her love and support as well as for her wise editorial advice is far greater than I can say.</p>
<p class="BODY">Finally, I want to express my thanks to the many first-­year M.Div. students in TH01 who patiently listened to earlier versions of some of these chapters. Their questions, suggestions, and encouragement have been a continuous source of strength and joy to me. To all these students this book is gratefully dedicated.</p>
</div>
<div>
<p class="Basic-Paragraph"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Migliore_Faith_Seeking_Understanding_text-4.vue?29bad263